import { SpeciesEnum } from "../../../../../../__generated__/globalTypes";
import { ThankYouView } from "components/Signup/components/ThankYou/ThankYouView";
import { useMetadata } from "components/Signup/store/selectors/metadata";
import { useAllValidAnimals } from "components/Signup/store/selectors/animals";
import { SignUpProductEnum } from "components/Signup/flow/SignupFlow/types";
import { useLeadAllianceTracking } from "components/Signup/components/ThankYou/useLeadAllianceTracking";

const shouldRenderLiabilityBanner = ({
  species,
  product,
}: {
  species: SpeciesEnum;
  product: SignUpProductEnum;
}) => {
  return product !== SignUpProductEnum.liability && species === SpeciesEnum.dog;
};

const ThankYou = () => {
  const { purchaseCompleted } = useMetadata();
  const animals = useAllValidAnimals();

  useLeadAllianceTracking({
    purchaseCompleted: purchaseCompleted,
    animals,
  });

  return (
    <ThankYouView
      showTractiveBanner
      showLiabilityBanner={
        animals.length === 1 &&
        shouldRenderLiabilityBanner({
          species: animals[0].species as SpeciesEnum,
          product: animals[0].insurances[0].product as SignUpProductEnum,
        })
      }
      showMultipetBanner={
        animals.length === 1 &&
        animals[0].insurances[0].product !== SignUpProductEnum.liability
      }
    />
  );
};

export default ThankYou;
